module.exports = __webpack_public_path__ + "static/illness-mobile-9004b3c525106692387d8cb95919636e.jpg";